import React from 'react'

export default function ScreenshotsSection({
  title,
  description,
  screenshots,
}) {
  return (
    <section
      id="screenshot"
      data-scroll-index="2"
      className="main-section center-align"
    >
      <div className="container">
        {/*<!--Title-->*/}
        <h4 className="reflection-text p-b-2">{title}</h4>

        {/*<!-- Description -->*/}
        <p className="p-t-1 desc">{description}</p>

        <div className="carousel">
          {screenshots.map(s => (
            <div className="carousel-item" key={s.src}>
              {/*<!-- Link to the image to open in full screen when clicked with lity plugin -->*/}
              <a href={s.src} data-lity>
                {/*<!-- Screenshot Image -->*/}
                <img alt="" className="responsive-img" {...s} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/ScreenshotsSection.js